export const isQaEnvironment = () => {
  const qaEnvs = ['qa', 'qa2', 'local', 'main', 'dev'];
  return qaEnvs.some(env => process.env.REACT_APP_API_ROOT?.startsWith(`https://${env}.`));
};